import { DateTime } from 'luxon'

const fmt = (iso: string | undefined) => {
  if (!iso) return ''
  const dt = DateTime.fromISO(iso).toLocal()
  return dt.isValid ? ` (${dt.toFormat('M/d/yy h:mm a')})` : ''
}

export const getVersionTooltip = (): string => {
  const commitSha = process.env.REACT_APP_COMMIT_SHA
  const deployId = process.env.REACT_APP_DEPLOY_ID
  const commitDate = process.env.REACT_APP_COMMIT_DATE
  const deployDate = process.env.REACT_APP_DEPLOY_DATE

  const commit = commitSha ? commitSha.slice(0, 7) : 'local'
  const deploy = deployId
    ? deployId.replace(/^dpl_/, '').slice(0, 9)
    : 'local'

  return `commit: ${commit}${fmt(commitDate)}\ndeploy: ${deploy}${fmt(deployDate)}`
}
